import React, {
  useState,
  useEffect
} from 'react';

import { makeStyles } from '@material-ui/core/styles';
import {
  Paper,
  Divider,
  Typography,
  TableContainer,
  Table,
  TableCell,
  TableHead,
  TableBody,
  TableRow,
  Button,
} from '@material-ui/core';
import CircleIcon from '@material-ui/icons/FiberManualRecord';

import localization from '../../../utils/localizations';


const useStyles = makeStyles((theme) => ({
  mainBody: {
    padding: 10,
    marginBottom: 20,
  },
  alert: {
    marginBottom: 10,
    marginTop: 10,
  },
  panelTitle: {
    marginTop: 10,
    marginBottom: 10,
  },
  mainTable: {
    
  },
  table: {

  }
}));
 

function ThesisSchedule() {
  const classes = useStyles();
  return (
  <Paper className={classes.mainBody}>
    <Typography variant="h5" className={classes.panelTitle}>{localization.thesisSchedule} 2020</Typography>
    <Divider />

    <TableContainer className={classes.mainTable}>
      <Table className={classes.table} aria-label={localization.thesisStage} size="small">
        <TableHead>
          <TableRow>
            <TableCell>{localization.thesisStage}</TableCell>
            <TableCell colSpan={7}>{localization.month}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell component="th" scope="row">{localization.ugb}</TableCell>
            <TableCell align="center"><CircleIcon /></TableCell>
            <TableCell align="center"><CircleIcon /></TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="center"></TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">{localization.proposal}</TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="center"><CircleIcon /></TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="center"></TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">{localization.firstSeminar}</TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="center"><CircleIcon /></TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="center"></TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">{localization.secondSeminar}</TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="center"><CircleIcon /></TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="center"></TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">{localization.thesisDefense}</TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="center"><CircleIcon /></TableCell>
            <TableCell align="center"><CircleIcon /></TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  </Paper>);
}

export {ThesisSchedule};